export class HeimdallWidget {

  static defaultConfig = {
    timeRate: 200,
    showTime: true,
    startTime: new Date(0),
    showEarth: true,
    backgroundColor: 'black',
    aspectFixed: false
  };

  swaths = {};

  lastRealTime = Date.now();
  currentRealTime = Date.now();

  tickHandlers = [];
  pauseHandlers = [];
  resizeHandlers = []

  constructor(config) {

    this.config = {
      ...HeimdallWidget.defaultConfig,
      ...config
    };

    this.simTime = structuredClone(this.config.startTime);

    this.DOMElement = document.getElementById(this.config.widgetID);
    this.DOMElement.classList.add('dataviz-widget');
    this.DOMElement.setAttribute('tabindex', '1');
    if(!this.config.aspectFixed){
      this.DOMElement.style['height'] = "100%";
    }

    this.DOMElement.addEventListener("keydown", this.keydown.bind(this));
    window.addEventListener('resize', this.resize.bind(this));

    // time ticker
    this.frameTicker();
  }

  resize(event) {

    let width = 0;
    let height = 0;

    if(
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement){
      width = window.innerWidth;
      height = window.innerHeight;
    } else {
      width = this.DOMElement.clientWidth;
      if(this.config.aspectFixed){
        height = this.DOMElement.clientWidth;
      } else {
        height = this.DOMElement.clientHeight;
      }
    }

    this.resizeHandlers.forEach(handler => {
      handler(width, height);
    });

  }

  unpause(){
    if (this.config.paused) {
      this.config.timeRate = this.config.unpausedTimeRate;
      this.config.paused = false;
    }
  }

  togglePause(){

    if (this.config.paused) {
      this.config.timeRate = this.config.unpausedTimeRate;
      this.config.paused = false;
    } else {
      this.config.unpausedTimeRate = this.config.timeRate;
      this.config.timeRate = 0;
      this.config.paused = true;
    }

    this.pauseHandlers.forEach(handler => {
      handler(this.config.paused);
    });

  }

  toggleFullscreen(){
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      var element = this.DOMElement.parentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    }
  }

  keydown(event) {
    if (event.key == 'p') {
      this.togglePause();
    } else if (event.key == 'f') {
      this.toggleFullscreen();
    }
  }

  frameTicker() {

    requestAnimationFrame(this.frameTicker.bind(this));

    this.lastRealTime = this.currentRealTime;
    this.currentRealTime = Date.now();
    let elapsedTime = this.currentRealTime - this.lastRealTime;

    this.lastSimTime = structuredClone(this.simTime);
    this.simTime.setTime(this.simTime.getTime() + this.config.timeRate * elapsedTime);

    this.tickHandlers.forEach(handler => {
      handler(this.simTime, this.lastSimTime);
    });

  }

  addTickHandler(handler){
    this.tickHandlers.push(handler);
  }

  addPauseHandler(handler){
    this.pauseHandlers.push(handler);
  }

  addResizeHandler(handler){
    this.resizeHandlers.push(handler);
  }

}
